import React from 'react';
import { useTheme } from 'styled-components';

import { getColor } from '../../V2/Elements/Icons/helpers.ts';
import type { IIcon } from './types.ts';

const Icon = React.forwardRef<SVGSVGElement | null, IIcon>(function Icon({ size = 24, alt, color, className, onClick }, ref) {
  const theme = useTheme();
  const fillColor = React.useMemo(() => getColor({ color, alt, theme }), [color, alt, theme]);
  return (
    <svg ref={ref} onClick={onClick} width={size} height={size} viewBox='0 0 24 24' fill='none' className={className}>
      <path d='M12 4V20' stroke={fillColor} strokeWidth='1.6' strokeLinecap='round' strokeLinejoin='round' />
      <path
        d='M16.1667 7H9.91667C9.14312 7 8.40125 7.26339 7.85427 7.73223C7.30729 8.20107 7 8.83696 7 9.5C7 10.163 7.30729 10.7989 7.85427 11.2678C8.40125 11.7366 9.14312 12 9.91667 12H14.0833C14.8569 12 15.5987 12.2634 16.1457 12.7322C16.6927 13.2011 17 13.837 17 14.5C17 15.163 16.6927 15.7989 16.1457 16.2678C15.5987 16.7366 14.8569 17 14.0833 17H7'
        stroke={fillColor}
        strokeWidth='1.6'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
});

export default React.memo(Icon);
